import { render, staticRenderFns } from "./MegaMenuTree.vue?vue&type=template&id=314b830b&"
import script from "./MegaMenuTree.vue?vue&type=script&lang=js&"
export * from "./MegaMenuTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports